export enum TemplateCategory {
  EMPLOYEE = 'EMPLOYEE',
  ADMINISTRATIVE = 'ADMINISTRATIVE',
}
